export default {
    events: {},
    gaBlackList: [
        'application.moved',
        'modals.close',
        'portfolioCarousel.slide',
        'portfolioCarousel.contentType',
        'singleMessageModal.show',
        'profileView.print',
        'applicationsPage.tabChange.Demoted',
        'applicationsPage.sortBy',
        'optionsModal.show',
        'ProfileView.application.next',
        'country.change',
        'applicationsPage.tabChange.Pending',
        'contentModal.show',
        'shortlistModal.show'
    ],

    on(eventName, callback, nodeId = '') {
        if (!this.events.hasOwnProperty(eventName)) {
            this.events[eventName] = [];
        }

        this.events[eventName].push({ callback, nodeId });
    },

    off(eventName, nodeId = '') {
        if (!this.events.hasOwnProperty(eventName)) {
            return;
        }

        if (this.events[eventName].length === 1) {
            delete this.events[eventName];
        }

        for (let key in this.events[eventName]) {
            if (this.events[eventName].hasOwnProperty(key) && this.events[eventName][key].nodeId === nodeId) {
                this.events[eventName].splice(key, 1);
            }
        }
    },

    fire(eventName, data, GaEventName = null) {
        let name = GaEventName ? GaEventName : eventName;

        if (window.env === 'production' && this.gaBlackList.indexOf(name) === -1) {
            // do not push any evernts to the datalayer for now
            // instead pass sendAnalyticsPageView() a modal name in order to track the modal open in analytics

            // if we wanted to record events, we'd push to the datalayer.
            
            // window.dataLayer = window.dataLayer || [];
            // dataLayer.push({'event': 'mandyJavascriptEvent', 'category' : `ReactEvent_${name}`});

            
        }

        if (this.events.hasOwnProperty(eventName)) {
            this.events[eventName].map(function (event) {
                if (event.hasOwnProperty('callback')) {
                    event.callback(data);
                }
            })
        }
    }
};
